import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import BlogBoxHome from "../../Component/BlogsCMPT/BlogBoxHome";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import "./BlogCSS.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function Blogs() {
  const { RendomTokenfetch, Pagemetatags } = useAuth();
  const [blogData, setBlogData] = useState([]);
  // console.log(blogData);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [TotalBlogs, setTotalBlogs] = useState(1);

  const limit = 6; // per page blogs

  const FetchBlogData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(`${WebsiteAPIurl}blogAPI.php?page=${currentPage}&limit=${limit}`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setBlogData(response.data.blogdata);
            setTotalPages(response.data.totalPages);
            setTotalBlogs(response.data.totalBlogs);
          }
          if (response.data.status === "0") {
            setBlogData([]);
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, currentPage]);

  useEffect(() => {
    FetchBlogData();
  }, [FetchBlogData]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  // 🟢 Pagination Buttons
  const renderPagination = () => {
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={`px-3 py-1 mx-1 rounded-lg border 
            ${
              currentPage === i
                ? "bg-red-600 text-white border-red-600"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
            }`}
        >
          {i}
        </button>
      );
    }
    return pages;
  };
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.newstitle}</title>
        <meta name="description" content={Pagemetatags.newsdescription} />
        <meta name="keywords" content={Pagemetatags.newskeyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Blogs" mainpage="" />

      <section className="news-section section-padding section-bg">
        <div className="right-shape">
          <img alt="img" src="assets/img/home-1/about/right-shape.png" />
        </div>
        <div className="container">
          <div className="row g-4">
            {loading ? (
              <p className="text-center">Loading blogs...</p>
            ) : blogData.length > 0 ? (
              blogData.map((val) => (
                <BlogBoxHome key={val.id || val._id} blogdata={val} />
              ))
            ) : (
              <p className="text-center">No blogs available right now.</p>
            )}
          </div>

          {/* Pagination */}

          {TotalBlogs > limit && (
            <div className="flex justify-center mt-5 text-center">
              <button
                onClick={() =>
                  setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev))
                }
                disabled={currentPage === 1}
                className="px-3 py-1 mx-1 rounded-lg border bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50"
              >
                ⬅ Prev
              </button>

              {renderPagination()}

              <button
                onClick={() =>
                  setCurrentPage((prev) =>
                    prev < totalPages ? prev + 1 : prev
                  )
                }
                disabled={currentPage === totalPages}
                className="px-3 py-1 mx-1 rounded-lg border bg-white text-gray-700 border-gray-300 hover:bg-gray-100 disabled:opacity-50"
              >
                Next ➡
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
